import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseButtonDefaults from '../BaseButton/BaseButton.defaults'

export default {

  ...merge(cloneDeep(baseDefaults), {base: {alignment: {desktop: 'center'}}}),

  buttons: [ 'buttonOne' ],

  spread: {
    desktop: 'basic',
    mobile: 'stackedFullWidth'
  },

  spacing: {
    desktop: 10
  },

  buttonOne: cloneDeep(baseButtonDefaults),

  buttonTwo: cloneDeep(baseButtonDefaults)
  
}
